// La scala di anteprima salvata a DB descrive i file generati AL CARICAMENTO del PDF, ma le
// anteprime su disco possono essere state riscritte dopo a scala diversa lasciando il valore
// vecchio: fidarsi di quel valore fa calcolare la pagina reale col doppio (o la metà) della
// dimensione giusta, con le gabbie disegnate fuori posto. L'immagine realmente caricata e la
// larghezza raster vera della pagina (rasterPageWidth, comunicata dal server nella risposta
// di GET /preprocess) permettono invece di MISURARE la scala, come rapporto fra le due.
// `fallbackScale` (il previewScale dichiarato dal server) resta il ripiego per immagine non
// caricata o riferimento assente.
//
// Il tetto 1.05: un'anteprima non è mai più grande della pagina reale (il server limita la
// scala a [0.2, 1]); un rapporto maggiore significa che rasterPageWidth non è la larghezza
// raster (sui volantini storici il server ripiega sulla larghezza export a 72 dpi) e si torna
// al valore dichiarato dal server.
export function resolvePreviewScale(image, rasterPageWidth, fallbackScale)
{
	if (image?.width > 0 && rasterPageWidth > 0)
	{
		const derived = image.width / rasterPageWidth;
		if (Number.isFinite(derived) && derived > 0 && derived <= 1.05)
			return derived;
	}
	return fallbackScale > 0 ? fallbackScale : 1;
}
